webpackJsonp([14533351238112516000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/react-intro/more-on-jsx.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainLayout = __webpack_require__("./src/components/MainLayout.jsx");
	
	var _MainLayout2 = _interopRequireDefault(_MainLayout);
	
	var _CtaButton = __webpack_require__("./src/components/CtaButton.jsx");
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	var _Block = __webpack_require__("./src/components/Block.jsx");
	
	var _Block2 = _interopRequireDefault(_Block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initReactJsx = '\n<html>\n<head>\n  <script src="https://cdnjs.cloudflare.com/ajax/libs/react/16.2.0/umd/react.development.js"></script>\n  <script src="https://cdnjs.cloudflare.com/ajax/libs/react-dom/16.2.0/umd/react-dom.development.js"></script>\n  <script src="https://cdnjs.cloudflare.com/ajax/libs/babel-standalone/6.26.0/babel.js"></script>\n</head>\n\n<body>\n  <div id="app">\n  </div>\n</body>\n\n<script type="text/babel">\n   var app = document.getElementById(\'app\')\n   var ele = <h1>Hello world</h1>\n   var para = <p> This is going to be awesome </p>\n   var parent = <div>{ele} {para}</div>\n   ReactDOM.render(parent, app)\n</script>\n</html>\n';
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _MainLayout2.default,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Block2.default, { title: 'Multiple elements in JSX', lang: 'html', value: initReactJsx }),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' Please try without the curly braces to see what happens. So far we saw how to create react dom elements and how to finally render into an actual DOM element.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' Next, you to need learn 3 things, then you\'re done learning Reactjs. The three things are:'
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Component'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'State'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Lifecycle methods'
	                )
	            ),
	            _react2.default.createElement(
	                _CtaButton2.default,
	                { to: '/react-intro/component' },
	                'What is a component?'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-react-intro-more-on-jsx-jsx-02e8fe462c4b02124e60.js